import { render as defRender, Fragment } from 'preact';
import { useState, useEffect, useRef, useReducer, useMemo, useCallback } from 'preact/hooks';

import { h, pp } from './super-h-props';
import { menu } from './menu';
import { update } from './immutability';
import { tabs } from './tabs';
import { fontSize } from './font-size';
import { themeToggle } from './theme-toggle';
import { menuNav, navUpdate } from './menu-nav';
import { gabc, gabcResize } from './gabc';
import { lazy, onLazy } from './lazy';
import { useHash, rootPath } from './use-hash';
import { fullScreen } from './full-screen-toggle';

const render = (pdom, ctrEl, replEl) => {
  if (typeof ctrEl === 'string') ctrEl = document.querySelector(ctrEl);
  if (typeof replEl === 'string') replEl = document.querySelector(replEl);
  return defRender(pdom, ctrEl, replEl);
};

const stdMenu = ({ lsPrefix, onResize, ctlChildren, children }) => {
  // console.log(ctlChildren, children);
  return h(menu, null,
    h('div', { class: 'ctl-group' },
      h(fullScreen, { short: true }),
      h(fontSize, { lsName: lsPrefix ? lsPrefix + '-font-size' : null, onResize }),
      h(themeToggle, { lsName: lsPrefix ? lsPrefix + '-night-theme' : null }),
      ctlChildren,
    ),
    children,
  );
};

export const preact = {
  h,
  pp,
  render,
  Fragment,
  useEffect,
  useState,
  useRef,
  useReducer,
  useHash,
  useMemo,
  useCallback,
  rootPath,
  update,
  c: {
    stdMenu,
    menu,
    fontSize,
    themeToggle,
    menuNav,
    navUpdate,
    gabc,
    gabcResize,
    lazy,
    fullScreen,
    onLazy,
    tabs,
  },
};
